<a class="tapp-link"
   [routerLink]="item?.link"
   [queryParams]="item?.queryParams"
   routerLinkActive="{{item?.link ? 'active' : ''}}"
   fxLayout="row"
   fxLayoutGap="15px"
   fxLayoutAlign="start center">
    <nb-icon *ngIf="item.evaIcon" [icon]="item.evaIcon"></nb-icon>
    <mat-icon *ngIf="item.materialIcon">{{item.materialIcon}}</mat-icon>
    <span>{{item.title}}</span>
</a>
